import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { QUERY_PARAMS } from "@/routes/_constants";
import { PATHS } from "@/routes/paths";

import { DiscountLongTermStayNewPage } from "@/components/features/items/discount/item/long-term-stay/new/ui";
import { DiscountMultiNewPage } from "@/components/features/items/discount/item/multi/new/ui";
import { DiscountOrdinaryNewPageContainer } from "@/components/features/items/discount/item/ordinary/new/ui";

import { useConfirmParams } from "./hooks";

export const DiscountNewPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID, type } = result;

	if (type === "ordinary")
		return (
			<PageMeta
				title="通常ディスカウントの作成"
				url={generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.NEW, {
					hotelID,
					type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.ORDINARY,
				})}
			>
				<DiscountOrdinaryNewPageContainer hotelID={hotelID} />
			</PageMeta>
		);

	if (type === "long-term-stay")
		return (
			<PageMeta
				title="連泊ディスカウントの作成"
				url={generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.NEW, {
					hotelID,
					type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.LONG_TERM_STAY,
				})}
			>
				<DiscountLongTermStayNewPage hotelID={hotelID} />
			</PageMeta>
		);

	return (
		<PageMeta
			title="複合ディスカウントの作成"
			url={generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.NEW, {
				hotelID,
				type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.MULTI,
			})}
		>
			<DiscountMultiNewPage hotelID={hotelID} />
		</PageMeta>
	);
};
